import { useAtomValue } from 'jotai'
import * as React from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router'

import LoginCard from '../components/cards/LoginCard'
import { isAuthenticatedAtom } from '../domains/auth/AuthSelectors'

export default function Login() {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)
  const navigate = useNavigate()
  const location = useLocation()

  const afterLogin = () => {
    if (!isAuthenticated) {
      return
    }

    if (location.state?.redirectTo) {
      navigate(location.state.redirectTo)
    } else {
      navigate('/')
    }
  }

  if (isAuthenticated) {
    if (location.state?.redirectTo) {
      return <Navigate to={location.state.redirectTo} replace />
    }
    return <Navigate to="/" replace />
  }

  return <LoginCard title="Sign in" afterLogin={afterLogin} />
}
